<template>
  <v-list-item
    v-if="canViewVerticalNavMenuLink(item)"
    v-bind="linkProps"
    :class="{'bg-gradient-primary white--text': isActive, 'vertical-nav-menu-link--badged': item.badge}"
    class="vertical-nav-menu-link"
    active-class="bg-gradient-primary"
  >
    <v-list-item-icon>
      <v-icon
        :class="{'alternate-icon-small': !item.icon}"
        :color="isActive ? 'white': null"
      >
        {{ item.icon || alternateIcon }}
      </v-icon>
    </v-list-item-icon>

    <!-- Подпись под названием пункта, например «Тестовый режим» у «Оплаты
         лицензий»: метке рядом с названием в меню не хватает ширины. -->
    <v-list-item-content
      v-if="item.note"
      class="py-0"
    >
      <v-list-item-title :class="{'white--text': isActive}">
        {{ t(item.title) }}
      </v-list-item-title>
      <v-list-item-subtitle
        class="text-xs"
        :class="isActive ? 'white--text' : `${item.noteColor || 'warning'}--text`"
      >
        {{ t(item.note) }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-title
      v-else
      :class="{'white--text': isActive}"
    >
      {{ t(item.title) }}
    </v-list-item-title>
    <v-list-item-action
      v-if="item.badge"
      class="flex-shrink-0"
    >
      <v-badge
        :color="item.badgeColor"
        inline
        :content="t(item.badge)"
      >
      </v-badge>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useVerticalNavLink from '@core/layouts/composable/vertical-nav/useVerticalNavLink'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps } = useVerticalNavLink(props.item)
    const { t } = useUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      alternateIcon: themeConfig.menu.groupChildIcon,

      // i18n
      t,

      // ACL
      canViewVerticalNavMenuLink,
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }

  // Плашка справа от названия («новое» у «Расчёта стоимости») обрезалась
  // краем меню (шеф, 30.10.2026): название не уступало ей место, а у блока
  // действия был свой отступ. Название сжимается с многоточием, плашка
  // целиком помещается в строке.
  .v-list-item__title {
    flex: 1 1 auto;
    min-width: 0;
  }

  // !important: у Vuetify свои отступы блока действия и плашки с большей
  // точностью правила (.v-list-item__action:last-of-type:not(:only-child)).
  .v-list-item__action {
    flex: 0 0 auto;
    margin-left: 4px !important;
    margin-right: 0 !important;
    min-width: 0;
  }

  // Плашка компактнее обычной, чтобы «Расчёт стоимости» и «новое» вместе
  // уместились в ширину меню.
  .v-badge--inline {
    margin: 0;
  }

  .v-badge--inline .v-badge__wrapper {
    margin: 0;
  }

  .v-badge--inline .v-badge__badge {
    white-space: nowrap;
    font-size: 10px;
    height: 16px;
    min-width: 0;
    padding: 2px 5px;
    line-height: 12px;
  }

  &--badged {
    padding-right: 10px !important;
  }
}
</style>
